import React from 'react'

export default function TelegramOffer() {
  return (
    <div  className='TelegramOffer'>
      <div className="telegram-offerbg">
        <div data-aos="zoom-in-up" className="container">
          <h2>Telegram kanalimizga taklif qilamiza</h2>
          <p>Dam olish uchun eng yaxshi variantlar haqida bilib olishingiz mumkin</p>
          <a href="https://t.me/joinchat/AAAAAFQOQc28o3fCfIWNTQ">
            <div className='offer-button'>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.09983 14.997C11.9097 14.997 14.9982 11.9085 14.9982 8.09861C14.9982 4.28872 11.9097 1.2002 8.09983 1.2002C4.28994 1.2002 1.20142 4.28872 1.20142 8.09861C1.20142 11.9085 4.28994 14.997 8.09983 14.997Z" fill="#FFDD00"/>
                <path d="M8 0C3.57993 0 0 3.58226 0 8C0 12.4177 3.57993 16 8 16C12.4201 16 16 12.4201 16 8C16 3.57993 12.4201 0 8 0ZM11.93 5.48191L10.6161 11.6686C10.5181 12.1074 10.259 12.2147 9.89265 12.007L7.89265 10.5321L6.92882 11.4609C6.82147 11.5683 6.73279 11.6569 6.52509 11.6569L6.66744 9.62194L10.3734 6.27305C10.5344 6.13069 10.3384 6.05134 10.1237 6.19137L5.54492 9.07818L3.5706 8.46208C3.14119 8.32672 3.13186 8.03267 3.66161 7.82731L11.3746 4.85181C11.7316 4.72345 12.0443 4.93816 11.93 5.48191Z" fill="white"/>
              </svg>
              <span>Kirish</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  )
}
